import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CalendarTodayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"calendar_today"}/>
}
